
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("1Pa6a", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "JiraAutomationSettingsPage", () => $42a70a7c6b4e272a$export$9f0de1aaf472742a);
$parcel$export(module.exports, "default", () => $42a70a7c6b4e272a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("kQSGw");

var $kwce8 = parcelRequire("kwce8");

var $fee69 = parcelRequire("fee69");

var $bNe1g = parcelRequire("bNe1g");

var $kJlBc = parcelRequire("kJlBc");

var $kCywN = parcelRequire("kCywN");

var $gd0Sp = parcelRequire("gd0Sp");

var $gMCwC = parcelRequire("gMCwC");
const $42a70a7c6b4e272a$var$METRICS_PAGE_ID = 'project-settings-apps.jira-automation';
class $42a70a7c6b4e272a$export$9f0de1aaf472742a extends (0, $eUqFw.Component) {
    render() {
        const { projectKey: projectKey } = this.props.match.params;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kCywN.ProjectSettingsController), {
            projectKey: projectKey
        }, this.renderContents());
    }
    constructor(...args){
        super(...args);
        this.renderContents = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fee69.ErrorBoundaryFlag), {
                id: $42a70a7c6b4e272a$var$METRICS_PAGE_ID
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bNe1g.ProjectContextProvider), null, (projectContext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwce8.ThemeProvider), {
                        theme: {}
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gMCwC.default), {
                        tenantContext: tenantContext,
                        projectContext: projectContext.data
                    }))))));
    }
}
var $42a70a7c6b4e272a$export$2e2bcd8739ae039 = (0, $kJlBc.withRouter)($42a70a7c6b4e272a$export$9f0de1aaf472742a);

});
parcelRegister("kCywN", function(module, exports) {

$parcel$export(module.exports, "ProjectSettingsController", () => $d103d2cdc5840880$export$9e38610dc1164d7d);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $1ybV0 = parcelRequire("1ybV0");

var $eI64M = parcelRequire("eI64M");

var $kJlBc = parcelRequire("kJlBc");

var $bhwgQ = parcelRequire("bhwgQ");

var $gd0Sp = parcelRequire("gd0Sp");

var $3hSJ4 = parcelRequire("3hSJ4");
const $d103d2cdc5840880$var$ERROR_REPORTING_PACKAGE_ID = 'projectSettingsController';
const $d103d2cdc5840880$var$ERROR_REPORTING_PACKAGE_NAME = 'jiraSpaAppsSoftwareProjectSettingsController';
const $d103d2cdc5840880$export$9e38610dc1164d7d = ({ projectKey: projectKey, children: children })=>(0, $1ybV0.ff)('mcrtb-1670-wrap-js-error-boundary-around-project-settings-controller') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: $d103d2cdc5840880$var$ERROR_REPORTING_PACKAGE_ID,
        teamName: "morphinecake",
        packageName: $d103d2cdc5840880$var$ERROR_REPORTING_PACKAGE_NAME,
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bhwgQ.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d103d2cdc5840880$var$RedirectNonAdminsAndArchivedProjects, {
        projectKey: projectKey
    }, children))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bhwgQ.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d103d2cdc5840880$var$RedirectNonAdminsAndArchivedProjects, {
        projectKey: projectKey
    }, children));
const $d103d2cdc5840880$var$RedirectNonAdminsAndArchivedProjects = ({ projectKey: projectKey, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        if (!projectKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
            to: "/jira/projects"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3hSJ4.ProjectContextSubscriber), null, (projectContext)=>{
            if (projectContext.isProjectArchived) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eI64M.RedirectToArchivedPage), null);
            if (tenantContext.isAdmin || projectContext.isProjectAdmin) return children;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
                to: `/projects/${projectContext.projectKey}`
            });
        });
    });

});
parcelRegister("eI64M", function(module, exports) {

$parcel$export(module.exports, "isProjectArchivedCondition", () => $949f89d276fadb14$export$34040938aec58f90);
$parcel$export(module.exports, "RedirectToArchivedPage", () => $949f89d276fadb14$export$36db2ddf32573bd8);
$parcel$export(module.exports, "default", () => $949f89d276fadb14$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bNe1g = parcelRequire("bNe1g");

var $kJlBc = parcelRequire("kJlBc");

const $949f89d276fadb14$export$34040938aec58f90 = (projectContextData)=>projectContextData && projectContextData.isProjectArchived || false;
const $949f89d276fadb14$var$RedirectIfProjectArchived = ({ projectKey: projectKey })=>{
    if (projectKey === null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bNe1g.ProjectContextProvider), null, (projectContext)=>$949f89d276fadb14$export$34040938aec58f90(projectContext.data) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
            to: (0, $8b47e2956ab1dffe$export$9a6ccb84170b615b)
        }) : null);
};
const $949f89d276fadb14$export$36db2ddf32573bd8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
        to: (0, $8b47e2956ab1dffe$export$9a6ccb84170b615b)
    });
var $949f89d276fadb14$export$2e2bcd8739ae039 = $949f89d276fadb14$var$RedirectIfProjectArchived;

});
const $8b47e2956ab1dffe$export$9a6ccb84170b615b = '/jira/errors/project-archived';


parcelRegister("3hSJ4", function(module, exports) {

$parcel$export(module.exports, "ProjectContextSubscriber", () => $21ed2776f26316f6$export$b6f3f3997ca8a783);

var $3HCkE = parcelRequire("3HCkE");

var $ixwgj = parcelRequire("ixwgj");
const $21ed2776f26316f6$export$b6f3f3997ca8a783 = ({ children: children })=>{
    const { data: data } = (0, $3HCkE.useResource)((0, $ixwgj.projectContextResourceWithCache));
    if (!data) return null;
    return children(data);
};

});


parcelRegister("gMCwC", function(module, exports) {

$parcel$export(module.exports, "default", () => $f06e28277049566d$export$2e2bcd8739ae039);

var $giAhk = parcelRequire("giAhk");

var $95aNu = parcelRequire("95aNu");
var $f06e28277049566d$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)((0, $95aNu.default));

});
parcelRegister("95aNu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e7d79086c23e0d7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7W3Ap = parcelRequire("7W3Ap");

var $kKe2o = parcelRequire("kKe2o");

var $ae4LH = parcelRequire("ae4LH");

var $jnBuK = parcelRequire("jnBuK");

var $ifUq1 = parcelRequire("ifUq1");

var $5Vpzc = parcelRequire("5Vpzc");
const $8e7d79086c23e0d7$var$JiraAutomationAppWrapper = ({ tenantContext: tenantContext, projectContext: projectContext, intl: { formatMessage: formatMessage } })=>{
    const { enabled: isLegacyAutomationEnabled } = (0, $jnBuK.useNavigationAutomationLegacyEnabledResource)().data || {};
    if (!projectContext || !tenantContext) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ae4LH.default), null);
    const { projectId: projectId, projectKey: projectKey, projectType: projectType } = projectContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ifUq1.default), {
        baseUrl: tenantContext.baseUrl,
        projectKey: projectKey,
        gridLayout: "fluid"
    }, isLegacyAutomationEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKe2o.default), {
        breadcrumb: {
            text: formatMessage((0, $5Vpzc.default).breadcrumb)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7W3Ap.default), {
        container: {
            id: projectId,
            key: projectKey,
            type: projectType
        }
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7W3Ap.default), {
        container: {
            id: projectId,
            key: projectKey,
            type: projectType
        }
    }));
};
var $8e7d79086c23e0d7$export$2e2bcd8739ae039 = $8e7d79086c23e0d7$var$JiraAutomationAppWrapper;

});
parcelRegister("7W3Ap", function(module, exports) {

$parcel$export(module.exports, "default", () => $15ef220e803251ed$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dfBCt = parcelRequire("dfBCt");

var $1ybV0 = parcelRequire("1ybV0");

var $iVQ7s = parcelRequire("iVQ7s");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $3e9vj = parcelRequire("3e9vj");
var $gd0Sp = parcelRequire("gd0Sp");

var $apl9V = parcelRequire("apl9V");

var $1dZhn = parcelRequire("1dZhn");
const $15ef220e803251ed$var$BOOTSTRAP_FILENAME = 'automationManagerBootstrap.pack.js';
let $15ef220e803251ed$var$isBootStrapBeenAppended = false;
const $15ef220e803251ed$export$1d6aa6cfe656cb32 = (jiraEnvironment, isAutomationDevInstance)=>{
    if (isAutomationDevInstance) {
        if (jiraEnvironment === 'staging') return 'dev';
        if (jiraEnvironment === 'prod') return 'test';
    }
    return jiraEnvironment === 'staging' ? 'staging' : 'prod';
};
/**
 * https://developer.atlassian.com/platform/bifrost/config/custom-domain/#custom-domain:-stating-your-own-identity
 * For fedramp, we return **environment type** rather than the **environment** itself.
 * @param environment
 * @param isFedRampInstance
 * @returns
 */ const $15ef220e803251ed$var$getBifrostEnvironment = (environment, isFedRampInstance = false)=>{
    let bifrostEnvironment;
    if (environment === 'staging') bifrostEnvironment = isFedRampInstance ? 'stg' : 'stg-east';
    else // it's empty for fedramp prod
    bifrostEnvironment = isFedRampInstance ? '' : 'prod-east';
    return bifrostEnvironment;
};
/**
 * Gets the correct Bifrost url suffix based on the perimeter
 */ const $15ef220e803251ed$var$getBifrostUrlSuffix = (isFedRampInstance)=>isFedRampInstance ? 'frontend.cdn.atlassian-us-gov-mod.com' : 'frontend.public.atl-paas.net';
const $15ef220e803251ed$var$generateBifrostBootstrapUrl = (env, buildNumber)=>{
    const isFedRampInstance = (0, $dfBCt.isFedRamp)();
    const bifrostUrlPrefix = 'https://automation-frontend';
    const bifrostEnvironment = $15ef220e803251ed$var$getBifrostEnvironment(env, isFedRampInstance);
    const bifrostUrlSuffix = $15ef220e803251ed$var$getBifrostUrlSuffix(isFedRampInstance);
    const bifrostBaseUrl = [
        bifrostUrlPrefix,
        bifrostEnvironment,
        bifrostUrlSuffix
    ]// remove empty strings
    .filter((str)=>str).join('.');
    const bifrostUrl = [
        bifrostBaseUrl,
        'assets',
        buildNumber,
        'bootstrap',
        $15ef220e803251ed$var$BOOTSTRAP_FILENAME
    ].join('/');
    return bifrostUrl;
};
const $15ef220e803251ed$export$d08bde130a2fd8bc = (env, buildNumber)=>{
    // Local dev source
    if (env === 'dev') return `https://localhost:8082/${$15ef220e803251ed$var$BOOTSTRAP_FILENAME}`;
    return $15ef220e803251ed$var$generateBifrostBootstrapUrl(env, buildNumber);
};
const $15ef220e803251ed$var$AutomationAppStackContextLoader = ({ container: container })=>{
    const { activationId: activationId, cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
    const isAutomationDevInstance = (0, $1ybV0.ff)('automation-dev-helper');
    const jiraEnvironment = (0, $3e9vj.useEnvironment)();
    const automationEnvironment = $15ef220e803251ed$export$1d6aa6cfe656cb32(jiraEnvironment, isAutomationDevInstance);
    const stackContext = (0, $1dZhn.default)(cloudId, automationEnvironment);
    if (stackContext.status === 'loading') // TODO: consider a better loading state, it's non-trivial as our bootstrap script also adds a loader and deletes it
    return null;
    if (stackContext.status === 'error') return(// TODO: i18n and analytics
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $apl9V.default), {
        title: "Failed to load Automation",
        description: stackContext.error
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($15ef220e803251ed$var$AutomationAppBody, {
        automationEnvironment: automationEnvironment,
        activationId: activationId,
        cloudId: cloudId,
        stackContext: stackContext.value,
        container: container
    });
};
const $15ef220e803251ed$var$BOOTSTRAP_ERROR_MESSAGE = 'Sorry, something went wrong loading Automation. Please try again.';
const $15ef220e803251ed$var$DEV_BOOTSTRAP_ERROR_MESSAGE = 'Are you running devWatch?';
const $15ef220e803251ed$var$AutomationAppBody = ({ automationEnvironment: automationEnvironment, activationId: activationId, cloudId: cloudId, stackContext: stackContext, container: container })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [bootStrapError, setBootStrapError] = (0, $eUqFw.useState)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (!$15ef220e803251ed$var$isBootStrapBeenAppended) {
            // eslint-disable-next-line jira/js/no-document-script
            const script = document.createElement('script');
            const src = $15ef220e803251ed$export$d08bde130a2fd8bc(automationEnvironment, stackContext.buildNumber);
            const startTime = performance.now();
            script.src = src;
            script.async = true;
            script.onload = ()=>{
                const duration = performance.now() - startTime;
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({
                    actionSubject: 'automationJiraEntry',
                    action: 'loaded'
                }), 'automationBootstrapFile loaded', {
                    duration: duration,
                    automationEnvironment: automationEnvironment
                });
            };
            script.onerror = async ()=>{
                const duration = performance.now() - startTime;
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({
                    actionSubject: 'automationJiraEntry',
                    action: 'failed'
                }), 'automationBootstrapFile failed', {
                    duration: duration,
                    automationEnvironment: automationEnvironment
                });
                setBootStrapError(automationEnvironment === 'dev' ? $15ef220e803251ed$var$DEV_BOOTSTRAP_ERROR_MESSAGE : $15ef220e803251ed$var$BOOTSTRAP_ERROR_MESSAGE);
                throw new Error(`Failed to load automation boostrap for env ${automationEnvironment}, src was '${src}'`);
            };
            document.body?.appendChild(script);
            $15ef220e803251ed$var$isBootStrapBeenAppended = true;
        }
    }, [
        automationEnvironment,
        createAnalyticsEvent,
        stackContext.buildNumber
    ]);
    // Lifecycle events automation application can respond to start the application, and destroy it.
    (0, $eUqFw.useEffect)(()=>{
        window.postMessage('automation-container-mounted');
        return ()=>{
            window.postMessage('automation-container-unmounted');
        };
    }, []);
    if (bootStrapError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $apl9V.default), {
        title: "Failed to load Automation",
        description: bootStrapError
    });
    const context = {
        activationId: activationId,
        cloudId: cloudId,
        scopeId: container?.id || 'GLOBAL',
        scopeKey: container?.key,
        scopeType: container?.type,
        productType: 'jira',
        env: automationEnvironment,
        staticPrefix: stackContext.staticPrefix,
        perimeter: stackContext.perimeter
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iVQ7s.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        id: "automation-container",
        "data-context": JSON.stringify(context),
        "data-testid": "automation.automation-app-container"
    }));
};
const $15ef220e803251ed$var$AutomationApp = ({ container: container })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($15ef220e803251ed$var$AutomationAppStackContextLoader, {
        container: container
    });
var $15ef220e803251ed$export$2e2bcd8739ae039 = $15ef220e803251ed$var$AutomationApp;

});
parcelRegister("iVQ7s", function(module, exports) {

$parcel$export(module.exports, "default", () => $3af258ecb27f0ff2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $3af258ecb27f0ff2$var$OpenHelpPanelLinkThroughEventListener = (0, $7rh0R.lazy)(()=>(parcelRequire("8J584")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/help-panel-button/src/services/open-help-panel-link-through-event-listener/index.tsx"
});
const $3af258ecb27f0ff2$export$9b28d5c0f56030a7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "open-help-panel-link-through-event-listener",
        packageName: "jira-help-panel-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-open-help-panel-link-through-event-listener",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3af258ecb27f0ff2$var$OpenHelpPanelLinkThroughEventListener, null)));
var $3af258ecb27f0ff2$export$2e2bcd8739ae039 = $3af258ecb27f0ff2$export$9b28d5c0f56030a7;

});
parcelRegister("8J584", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('4Cea4')
        ]);
        const value = parcelRequire('743zr');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("4Cea4")
    ]).then(()=>parcelRequire('743zr'));
}

});


parcelRegister("3e9vj", function(module, exports) {

$parcel$export(module.exports, "useEnvironment", () => $f75608ebab912e29$export$ea7ed2425832167d);
$parcel$export(module.exports, "useIsStagingOrDevOrLocal", () => $f75608ebab912e29$export$b0d8f74f433a09c9);

var $gd0Sp = parcelRequire("gd0Sp");
const $f75608ebab912e29$var$ENVIRONMENT = {
    STAGING: 'staging',
    DEV: 'dev',
    LOCAL: 'local',
    PROD: 'prod'
};
const $f75608ebab912e29$export$ea7ed2425832167d = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext?.environment || $f75608ebab912e29$var$ENVIRONMENT.PROD;
};
const $f75608ebab912e29$export$b0d8f74f433a09c9 = ()=>{
    const env = $f75608ebab912e29$export$ea7ed2425832167d();
    return env === $f75608ebab912e29$var$ENVIRONMENT.STAGING || env === $f75608ebab912e29$var$ENVIRONMENT.DEV || env === $f75608ebab912e29$var$ENVIRONMENT.LOCAL;
};

});

parcelRegister("apl9V", function(module, exports) {

$parcel$export(module.exports, "default", () => $a76a149d35e75d76$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $lRvnl = parcelRequire("lRvnl");
const $a76a149d35e75d76$var$BootstrapPage = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $a76a149d35e75d76$var$pageContainerStyles,
        testId: "automation.automation-platform-bootstrap-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $a76a149d35e75d76$var$contentContainerStyles
    }, props.children));
const $a76a149d35e75d76$var$BootstrapError = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a76a149d35e75d76$var$BootstrapPage, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
        appearance: "error",
        title: props.title
    }, props.description));
var $a76a149d35e75d76$export$2e2bcd8739ae039 = $a76a149d35e75d76$var$BootstrapError;
const $a76a149d35e75d76$var$pageContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '80vh'
});
const $a76a149d35e75d76$var$contentContainerStyles = (0, $1ZAYh.xcss)({
    justifyContent: 'center',
    width: '500px'
});

});

parcelRegister("1dZhn", function(module, exports) {

$parcel$export(module.exports, "default", () => $288199807d96fe06$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bDMnm = parcelRequire("bDMnm");
/**
 * dev and test don't have the best solutions.
 * test - on the first pass, it actually gets prod since the persistedStackId will be undefined.
 *        it then reaches the prod bootstrap logic which sets the testStackId and reloads
 * dev - it shouldn't come here, it will go to localhost first. this means the fallback is not yet supported.
 * @param bootstrapEnv
 * @returns
 */ const $288199807d96fe06$var$getApiPath = (bootstrapEnv)=>{
    if (bootstrapEnv === 'staging') return 'staging';
    const persistedTestStackId = window.sessionStorage.getItem('AUTOMATION_TEST_STACK_ID');
    if (bootstrapEnv === 'test' && typeof persistedTestStackId === 'string') return persistedTestStackId;
    return 'pro';
};
const $288199807d96fe06$var$getStackContextUrl = (cloudId, bootstrapEnv)=>`/gateway/api/automation/internal-api/jira/${cloudId}/${$288199807d96fe06$var$getApiPath(bootstrapEnv)}/rest/stackcontext`;
const $288199807d96fe06$var$DEV_STACK_CONTEXT = {
    // buildNumber is not actually used in dev since we don't redirect to bifrost, we serve from localhost
    buildNumber: 'automation-dev',
    staticPrefix: 'https://localhost:8088',
    perimeter: 'COMMERCIAL'
};
const $288199807d96fe06$var$useStackContext = (cloudId, bootstrapEnv)=>{
    const [stackContextResult, setStackContextResult] = (0, $eUqFw.useState)({
        status: 'loading',
        value: null,
        error: null
    });
    (0, $eUqFw.useEffect)(()=>{
        const abortController = new AbortController();
        const fetchStackContext = async ()=>{
            try {
                const response = await fetch($288199807d96fe06$var$getStackContextUrl(cloudId, bootstrapEnv), {
                    signal: abortController.signal
                });
                const data = await response.json();
                if (!(0, $bDMnm.isObjectStackContext)(data)) throw new Error('Something went wrong loading Automation');
                setStackContextResult({
                    status: 'success',
                    value: data,
                    error: null
                });
            } catch (e) {
                if (e instanceof Error) {
                    // no need to set error if it was aborted due to clean up
                    if (e.name === 'AbortError') return;
                    setStackContextResult({
                        status: 'error',
                        value: null,
                        error: e.message
                    });
                } else setStackContextResult({
                    status: 'error',
                    value: null,
                    error: String(e)
                });
            }
        };
        if (bootstrapEnv !== 'dev') fetchStackContext();
        return ()=>{
            abortController.abort();
        };
    }, [
        cloudId,
        bootstrapEnv
    ]);
    if (bootstrapEnv === 'dev') return {
        status: 'success',
        error: null,
        value: $288199807d96fe06$var$DEV_STACK_CONTEXT
    };
    return stackContextResult;
};
var $288199807d96fe06$export$2e2bcd8739ae039 = $288199807d96fe06$var$useStackContext;

});
parcelRegister("bDMnm", function(module, exports) {

$parcel$export(module.exports, "isObjectStackContext", () => $8cd388b628cc7df4$export$f2c8b2575b518327);
const $8cd388b628cc7df4$var$SUPPORTED_PERIMETERS = [
    'COMMERCIAL',
    'FEDRAMP'
];
const $8cd388b628cc7df4$export$f2c8b2575b518327 = (value)=>{
    if (typeof value !== 'object' || value === null) return false;
    // ignore @typescript-eslint/consistent-type-assertions because we are checking the type of the object
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const potentialStackContext = value;
    return typeof potentialStackContext.staticPrefix === 'string' && typeof potentialStackContext.buildNumber === 'string' && $8cd388b628cc7df4$var$SUPPORTED_PERIMETERS.includes(potentialStackContext.perimeter);
};

});



parcelRegister("jnBuK", function(module, exports) {

$parcel$export(module.exports, "useNavigationAutomationLegacyEnabledResource", () => $fe475fbcab8f8960$export$ca7c07083e4556cd);

var $3HCkE = parcelRequire("3HCkE");

var $l6RYU = parcelRequire("l6RYU");
const $fe475fbcab8f8960$export$ca7c07083e4556cd = ()=>{
    const { data: data, loading: loading } = (0, $3HCkE.useResource)((0, $l6RYU.navigationSidebarAutomationLegacyEnabledResource));
    return {
        data: data,
        loading: loading
    };
};

});

parcelRegister("ifUq1", function(module, exports) {

$parcel$export(module.exports, "default", () => $75607b44b71bf2f5$export$2e2bcd8739ae039);
/* app-container.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $j7bQJ = parcelRequire("j7bQJ");
var $6tahE = parcelRequire("6tahE");

var $7ehAr = parcelRequire("7ehAr");
var $c76ap = parcelRequire("c76ap");
var $dpXKE = parcelRequire("dpXKE");
var $1YMP9 = parcelRequire("1YMP9");

var $1ybV0 = parcelRequire("1ybV0");

var $bNe1g = parcelRequire("bNe1g");
const $75607b44b71bf2f5$var$AppContainer = ({ children: children, baseUrl: baseUrl, projectKey: projectKey, gridLayout: gridLayout, fullSize: fullSize = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bNe1g.ProjectContextProvider), null, ({ data: projectData })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($75607b44b71bf2f5$var$ConditionalGrid, {
            gridLayout: gridLayout,
            fullSize: fullSize
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ehAr.BreadcrumbManager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($75607b44b71bf2f5$var$BreadcrumbsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c76ap.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dpXKE.default), {
            baseUrl: baseUrl,
            projectKey: projectKey,
            projectName: projectData ? projectData.projectName : ''
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1YMP9.default), {
            baseUrl: baseUrl,
            projectKey: projectKey,
            projectType: projectData ? projectData.projectType : undefined,
            isSimplified: projectData ? projectData.simplified : false
        }, children)))));
var $75607b44b71bf2f5$export$2e2bcd8739ae039 = $75607b44b71bf2f5$var$AppContainer;
const $75607b44b71bf2f5$var$ConditionalGrid = ({ children: children, gridLayout: gridLayout, fullSize: fullSize })=>{
    if (fullSize && (0, $1ybV0.ff)('com.atlassian.connect.change-jira-appcontainer-to-better-support-jira-project-admin-tab-panel')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($75607b44b71bf2f5$var$FullHeightWrapper, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($75607b44b71bf2f5$var$NormalWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j7bQJ.default), {
        layout: gridLayout
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6tahE.default), null, children)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $75607b44b71bf2f5$var$NormalWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _kqswh2mm _1yt45gjp",
            __cmplp.className
        ])
    });
});
const $75607b44b71bf2f5$var$FullHeightWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $75607b44b71bf2f5$var$NormalWrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _1e0c1txw _2lx21bp4 _zulp1ejb",
            __cmplp.className
        ])
    });
});
const $75607b44b71bf2f5$var$BreadcrumbsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk1ejb _otyrmgjw _18u0r5cr _1tkepxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("j7bQJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $21cf405c5617943d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $cuCEk = parcelRequire("cuCEk");

var $gw8fk = parcelRequire("gw8fk");

var $6tahE = parcelRequire("6tahE");

var $02LzD = parcelRequire("02LzD");
/**
 * __Grid__
 *
 * A grid contains one or more `GridColumn` to provide a grid layout.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $21cf405c5617943d$var$GridWrapper = ({ spacing: spacingProp, columns: columnsProp, layout: layout, testId: testId, children: children, theme: theme })=>{
    /**
	 * isRoot is `true` only in the default context (i.e. no ancestor Grid).
	 */ const { isRoot: isRoot } = (0, $eUqFw.useContext)((0, $02LzD.GridContext));
    const { medium: medium } = (0, $eUqFw.useContext)((0, $6tahE.GridColumnContext));
    /**
	 * The colspan of the current containing GridColumn provides
	 * the default amount of columns in a nested grid.
	 */ const defaultColumns = medium > 0 ? medium : (0, $cuCEk.defaultGridColumns);
    /**
	 * This is to account for the eventual removal of the `theme` prop. In theory, this should not be exposed.
	 * However, consumers are still using it - there should be a major rerelease with the complete removal of this prop later.
	 */ const spacing = spacingProp ?? theme?.spacing ?? (0, $cuCEk.defaultSpacing);
    const columns = columnsProp ?? theme?.columns ?? defaultColumns;
    const isNested = theme?.isNestedGrid ?? !isRoot;
    const contextValue = (0, $eUqFw.useMemo)(()=>({
            isRoot: false,
            isNested: isNested,
            spacing: spacing,
            columns: columns
        }), [
        spacing,
        columns,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $02LzD.GridContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gw8fk.Grid), {
        layout: layout,
        testId: testId
    }, children));
};
var $21cf405c5617943d$export$2e2bcd8739ae039 = $21cf405c5617943d$var$GridWrapper;

});
parcelRegister("cuCEk", function(module, exports) {

$parcel$export(module.exports, "defaultGridColumns", () => $63536614c324c20f$export$74797698e12f8baa);
$parcel$export(module.exports, "defaultGridColumnWidth", () => $63536614c324c20f$export$b8241a1616ab1b96);
$parcel$export(module.exports, "spacingMapping", () => $63536614c324c20f$export$2a89a65a43bab52d);
$parcel$export(module.exports, "defaultSpacing", () => $63536614c324c20f$export$8ec7372efd74b753);
$parcel$export(module.exports, "defaultBannerHeight", () => $63536614c324c20f$export$d77f83c3d17a7b8a);
$parcel$export(module.exports, "defaultMedium", () => $63536614c324c20f$export$f8725d21f81f3e01);
$parcel$export(module.exports, "defaultLayout", () => $63536614c324c20f$export$2303d2bd9eeff99a);
$parcel$export(module.exports, "varColumnsNum", () => $63536614c324c20f$export$9ddc3632bbfb8966);
$parcel$export(module.exports, "varColumnSpan", () => $63536614c324c20f$export$8b7e31f391e6e681);
$parcel$export(module.exports, "varGridSpacing", () => $63536614c324c20f$export$936829b4511db3e4);
const $63536614c324c20f$export$3aaf3a78c909ea56 = 8;
const $63536614c324c20f$export$74797698e12f8baa = 12;
const $63536614c324c20f$export$b8241a1616ab1b96 = $63536614c324c20f$export$3aaf3a78c909ea56 * 10;
const $63536614c324c20f$export$2a89a65a43bab52d = {
    comfortable: $63536614c324c20f$export$3aaf3a78c909ea56 * 5,
    cosy: $63536614c324c20f$export$3aaf3a78c909ea56 * 2,
    compact: $63536614c324c20f$export$3aaf3a78c909ea56 * 0.5
};
const $63536614c324c20f$export$8ec7372efd74b753 = 'cosy';
const $63536614c324c20f$export$d77f83c3d17a7b8a = 52;
const $63536614c324c20f$export$f8725d21f81f3e01 = 0;
const $63536614c324c20f$export$2303d2bd9eeff99a = 'fixed';
const $63536614c324c20f$export$9ddc3632bbfb8966 = '--ds-columns-num';
const $63536614c324c20f$export$8b7e31f391e6e681 = '--ds-column-span';
const $63536614c324c20f$export$936829b4511db3e4 = '--ds-grid-spacing';

});

parcelRegister("gw8fk", function(module, exports) {

$parcel$export(module.exports, "Grid", () => $7946ba115b4da3a8$export$ef2184bd89960b14);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $cuCEk = parcelRequire("cuCEk");

var $02LzD = parcelRequire("02LzD");
function $7946ba115b4da3a8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7946ba115b4da3a8$var$gridStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `0 calc(var(${(0, $cuCEk.varGridSpacing)}) / 2)`,
    position: 'relative',
    alignItems: 'flex-start',
    flexWrap: 'wrap'
});
const $7946ba115b4da3a8$var$gridLayoutStyles = {
    fixed: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(var(${(0, $cuCEk.varColumnsNum)}) * ${(0, $cuCEk.defaultGridColumnWidth)}px)`
    }),
    fluid: {
        name: "qhxz92",
        styles: "max-width:100%"
    }
};
const $7946ba115b4da3a8$var$nestedGridStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(-1 * var(${(0, $cuCEk.varGridSpacing)}))`
});
const $7946ba115b4da3a8$export$ef2184bd89960b14 = ({ layout: layout = (0, $cuCEk.defaultLayout), testId: testId, children: children })=>{
    const { isNested: isNested, columns: columns, spacing: spacing } = (0, $eUqFw.useContext)((0, $02LzD.GridContext));
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $7946ba115b4da3a8$var$gridStyles,
            $7946ba115b4da3a8$var$gridLayoutStyles[layout],
            isNested && $7946ba115b4da3a8$var$nestedGridStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $cuCEk.varColumnsNum)]: columns,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $cuCEk.varGridSpacing)]: `${(0, $cuCEk.spacingMapping)[spacing]}px`
        },
        "data-testid": testId
    }, children);
};

});
parcelRegister("02LzD", function(module, exports) {

$parcel$export(module.exports, "GridContext", () => $abe6d6b3e91c4986$export$11cae3e04ab99fae);

var $eUqFw = parcelRequire("eUqFw");

var $cuCEk = parcelRequire("cuCEk");
const $abe6d6b3e91c4986$export$11cae3e04ab99fae = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isRoot: true,
    isNested: false,
    spacing: (0, $cuCEk.defaultSpacing),
    columns: (0, $cuCEk.defaultGridColumns)
});

});


parcelRegister("6tahE", function(module, exports) {

$parcel$export(module.exports, "GridColumnContext", () => $384e4fce86f51330$export$1229ad7112b989f5);
$parcel$export(module.exports, "default", () => $384e4fce86f51330$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $cuCEk = parcelRequire("cuCEk");

var $02LzD = parcelRequire("02LzD");
var $384e4fce86f51330$var$ColumnVariant;
/**
 * Determines the method by which column width is calculated.
 */ (function(ColumnVariant) {
    /**
   * Column occupies available space.
   *
   * Used when `medium` is 0 (the default).
   */ ColumnVariant["Auto"] = "auto";
    /**
   * Column occupies specified space.
   *
   * Used when 0 < `medium` < `columns`.
   */ ColumnVariant["Bounded"] = "bounded";
    /**
   * Column occupies entire row.
   *
   * Used when `medium` >= `columns`.
   *
   * This case is handled separately because of rounding.
   */ ColumnVariant["FullWidth"] = "fullWidth";
})($384e4fce86f51330$var$ColumnVariant || ($384e4fce86f51330$var$ColumnVariant = {}));
const $384e4fce86f51330$var$getVariant = ({ medium: medium, columns: columns })=>{
    if (medium === (0, $cuCEk.defaultMedium)) return "auto";
    else if (medium < columns) return "bounded";
    return "fullWidth";
};
/**
 * IE11 and Edge both have rounding issues for flexbox which is why a width of
 * 99.9999% is used. Using 100% here causes columns to wrap prematurely.
 */ const $384e4fce86f51330$var$availableWidth = '99.9999%';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $384e4fce86f51330$var$singleColumnWidth = `(${$384e4fce86f51330$var$availableWidth} / var(${(0, $cuCEk.varColumnsNum)}))`;
const $384e4fce86f51330$var$gridColumnStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: `calc(${$384e4fce86f51330$var$singleColumnWidth} - var(${(0, $cuCEk.varGridSpacing)}))`,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(var(${(0, $cuCEk.varGridSpacing)}) / 2)`,
    flexGrow: 1,
    flexShrink: 0,
    wordWrap: 'break-word'
});
const $384e4fce86f51330$var$gridColumnWidthStyles = {
    ["auto"]: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $cuCEk.varGridSpacing)}))`,
        flexBasis: `auto`
    }),
    ["bounded"]: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(${$384e4fce86f51330$var$singleColumnWidth} *  var(${(0, $cuCEk.varColumnSpan)}) - var(${(0, $cuCEk.varGridSpacing)}))`,
        flexBasis: `100%`
    }),
    ["fullWidth"]: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $cuCEk.varGridSpacing)}))`,
        flexBasis: `100%`
    })
};
const $384e4fce86f51330$export$1229ad7112b989f5 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    medium: (0, $cuCEk.defaultMedium)
});
/**
 * __Grid column__
 *
 * A grid column can span one or more column positions within a grid.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $384e4fce86f51330$var$GridColumn = ({ medium: medium = (0, $cuCEk.defaultMedium), children: children, testId: testId })=>{
    const { columns: columns } = (0, $eUqFw.useContext)((0, $02LzD.GridContext));
    const contextValue = (0, $eUqFw.useMemo)(()=>({
            medium: medium
        }), [
        medium
    ]);
    /**
   * The real column span,
   * obtained by clamping the passed `medium` value within the allowed range.
   */ const colSpan = Math.max(1, Math.min(medium, columns));
    /**
   * How we should calculate the column width.
   */ const variant = $384e4fce86f51330$var$getVariant({
        medium: medium,
        columns: columns
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)($384e4fce86f51330$export$1229ad7112b989f5.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $384e4fce86f51330$var$gridColumnStyles,
            $384e4fce86f51330$var$gridColumnWidthStyles[variant]
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            /**
       * The 'auto' value here isn't actually consumed anywhere and is
       * just to better reflect what is happening when inspecting CSS.
       */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $cuCEk.varColumnSpan)]: variant === "auto" ? 'auto' : colSpan
        },
        "data-testid": testId
    }, children));
};
var $384e4fce86f51330$export$2e2bcd8739ae039 = $384e4fce86f51330$var$GridColumn;

});


parcelRegister("1YMP9", function(module, exports) {

$parcel$export(module.exports, "default", () => $90e5325849889e8c$export$2e2bcd8739ae039);

var $giAhk = parcelRequire("giAhk");

var $7AJNu = parcelRequire("7AJNu");
var $90e5325849889e8c$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)((0, $7AJNu.default));

});
parcelRegister("7AJNu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a78352310a6c306$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $kKe2o = parcelRequire("kKe2o");

var $5IARc = parcelRequire("5IARc");

var $jBULE = parcelRequire("jBULE");
const $8a78352310a6c306$var$ProjectSettingsBreadcrumb = ({ baseUrl: baseUrl, children: children, projectKey: projectKey, projectType: projectType, isSimplified: isSimplified = false, intl: { formatMessage: formatMessage } })=>projectType && // <- we need this first condition just to avoid Flow error at createProjectSettingsUrl
    (projectType === (0, $7ZZxN.CORE_PROJECT) || projectType === (0, $7ZZxN.SOFTWARE_PROJECT) || projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKe2o.default), {
        breadcrumb: {
            href: (0, $5IARc.createProjectSettingsUrl)(baseUrl, projectKey, projectType, isSimplified),
            text: formatMessage((0, $jBULE.default).projectSettingsTitle),
            type: 'projectSettings'
        }
    }, children) : children;
var $8a78352310a6c306$export$2e2bcd8739ae039 = $8a78352310a6c306$var$ProjectSettingsBreadcrumb;

});
parcelRegister("jBULE", function(module, exports) {

$parcel$export(module.exports, "default", () => $b99c71c52f70e552$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b99c71c52f70e552$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    projectSettingsTitle: {
        "id": "platform.ui.breadcrumbs.common-breadcrumbs.project-settings.project-settings-title",
        "defaultMessage": "Project settings"
    }
});

});




parcelRegister("5Vpzc", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c14a05158baae91$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7c14a05158baae91$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    breadcrumb: {
        "id": "spa-apps.project-settings.jira-automation.breadcrumb",
        "defaultMessage": "Automation"
    }
});

});





//# sourceMappingURL=async-project-settings-jira-automation.7719dc44.js.map
